var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7668 0.74585C9.75152 0.74585 0 10.2677 0 22.0001C0 33.7324 9.75152 43.2543 21.7668 43.2543C33.782 43.2543 43.5336 33.7324 43.5336 22.0001C43.5336 10.2677 33.782 0.74585 21.7668 0.74585ZM17.4134 32.6272L6.53003 22.0001L9.59915 19.0032L17.4134 26.6123L33.9344 10.4803L37.0035 13.4984L17.4134 32.6272Z",
    fill: "#5BB974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.613b97257372a81a65846c9f46bd3960.svg";
export { ForwardRef as ReactComponent };